<template>
  <slot />
</template>
<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import useAuth from '@/composables/useAuth';
import useWebsockets from '@/composables/useWebsockets';
import {useEnvironmentStore} from '@/env/useEnvironmentStore';

const {t} = useI18n();
const {getToken} = useAuth();
const {environment} = useEnvironmentStore();

const token = await getToken();

const {init} = useWebsockets({
  heartBeat: !environment.devMode,
  environment: environment.environment,
});

init(token, t);
</script>
